import store from '@/store'
import axios from 'axios'
import Message from '@/components/message/index.js'

import util from '@/libs/util'
import router from '../../router'

// 创建一个错误
function errorCreate(msg) {
  const error = new Error(msg)
  //errorLog(error)
  throw error
}

// 记录和显示错误
function errorLog(error) {
  // 添加到日志
  store.dispatch('admin/log/push', {
    message: '数据请求异常',
    type: 'danger',
    meta: {
      error
    }
  })
  // 打印到控制台
  if (process.env.NODE_ENV === 'development') {
    util.log.danger('>>>>>> Error >>>>>>')
    console.log(error)
  }
  // 显示提示
  Message({
    message: error.message,
    type: 'danger',
    duration: 5 * 1000
  })
}

// 创建一个 axios 实例
const service = axios.create({
  baseURL: process.env.VUE_APP_API,
  timeout: 30000 // 请求超时时间
})



// 请求拦截器
service.interceptors.request.use(
  config => {
    // 在请求发送之前做一些处理
    const token = util.cookies.get('token')
    if (token !== undefined) {
      // 让每个请求携带token
      config.headers['Authorization'] = token
    }
    return config
  },
  error => {
    // 发送失败
    console.log(error)
    return Promise.reject(error)
  }
)

// 响应拦截器
service.interceptors.response.use(
  response => {
    // 如果响应头中包含token则将其放到cookie里
    let token = response.headers['authorization']
    if (token === undefined) {
      token = response.headers['Authorization']
    }
    if (token !== undefined) {
      util.cookies.set('token', token)
    }
    // dataAxios 是 axios 返回数据中的 data
    const dataAxios = response.data
    // 这个状态码是和后端约定的
    const {
      code
    } = dataAxios
    // 根据 code 进行判断
    if (code === undefined) {
      // 如果没有 code 代表这不是项目后端开发的接口 比如可能是 D2Admin 请求最新版本

      return dataAxios
    } else {
      // 有 code 代表这是一个后端接口 可以进行进一步的判断
      switch (code) {
        case '0':
          return dataAxios.data
        case 'user-103':
          errorCreate('账号或密码不正确')
          break
        case 'user-104':
          errorCreate('验证码信息不正确')
          break
        default:
          errorCreate(`${dataAxios.msg}`)
          break
      }
    }
  },
  error => {
    if (error && error.response) {
      switch (error.response.status) {
        case 400:
          error.message = '请求错误，请联系工作人员'
          break
        case 401:
          error.message = '需要登录后才能访问'
          util.cookies.remove("token")
          router.replace("/login")
          break
        case 403:
          error.message = '您没有权限访问该页面'
          break
        case 404:
          error.message = '请求错误，请联系工作人员'
          break
        case 408:
          error.message = '请求超时'
          break
        case 422:
          error.message = '参数错误'
          break
        case 500:
          if (error.message != 'post:RefreshJwtTokenFilter') {
            error.message = '服务器内部错误'
          } else {
            util.cookies.remove("token")
            util.cookies.remove("uuid")
            router.replace("/login")
          }
          break
        case 501:
          error.message = '服务未实现'
          break
        case 502:
          error.message = '网关错误'
          break
        case 503:
          error.message = '服务不可用'
          break
        case 504:
          error.message = '网关超时'
          break
        case 505:
          error.message = 'HTTP版本不受支持'
          break
        default:
          break
      }
    }
    errorLog(error)
    return Promise.reject(error)
  }
)

export default service